import { getAPIUrl } from "../utils/helper";

export const BASE_URL = getAPIUrl();
// auth
export const LOGIN_URL = "users/auth/login";
export const VALIDATE_LINK_URL = "users/validate_link";
export const VALIDATE_AZURE_LINK_URL = "users/entra/ssoSuccess";
export const SET_PASSWORD_URL = "users/auth/password/reset";
export const FORGOT_PASSWORD_URL = "users/auth/password/forgot";
export const SEND_PASSWORD_LINK_URL = "users/auth/resend";
export const REFRESH_TOKEN_URL = `${BASE_URL}users/auth/refresh`;
export const LOGOUT_URL = "users/auth/logout";
export const AZURE_LOGIN_URL = "entra/auth/login";
export const AZUERE_LOGOUT_URL = "entra/auth/logout";
// setings
export const USERS_URL = "users/users";
export const ROLES_URL = "users/roles";
export const TEMPLATE_URL = "template";
export const ALTERNATE_ROLE_URL = "users/updateuserrole";
export const CHANGE_PASSWORD_URL = "users/auth/password/change";
export const GET_FEATURES_URL = "users/features";
export const USER_PROFILE_URL = "users/profile";
export const GET_AUDIT_LOG_URL = "auditlog";
export const ANALYTICS_GRAPHS_URL = "analytics/graphs/";
export const USER_GRAPHS_URL = "users/graphs";
export const ALERT_URL = "alerts";
export const GET_TRIGGER_ALERT = "triggered-alerts";
export const GET_AIRCRAFT_FAMILY = "config/families/aircraft-families";
export const CREATE_AIRCRAFT_FAMILY_URL =
  "config/families/create_aircraft_family/";
export const UPDATE_AIRCRAFT_FAMILY_URL =
  "config/families/update_aircraft_family/";
export const ENGINE_FAMILY_URL = "config/families/";
export const TYPE_URL = "config/types";
export const APP_LOOKUP_URL = "application-lookup";
export const CONFIG_EXPORT_URL = "config/export";
export const CONFIG_VENDOR_URL = "config/vendor-dropdown-values";
export const BAM_USERS_URL = "users/bamapproveruser";
export const PN_DROPDOWN_URL = "analytics/filters/partnumber";
export const RV_DROPDOWN_URL = "analytics/filters/repair-vendors";
export const LLP_VALUES_URL = "projects/master-llp-values";
export const SALES_ESCALATION_URL = "sales-esclation";
export const REPAIRS_ESCALATION_URL = "repairs-esclation";
export const IMPORT_SALES_ESCALATION_URL = "config/import/sales-esclation";
export const IMPORT_REPAIRS_ESCALATION_URL = "config/import/repairs-esclation";
export const PARTS_MASTERS_URL = "partsmaster";
export const CUSTOMER_PN_DROPDOWN_URL =
  "analytics/customerQuote/company_pn_list";

// export const AIRCRAFT_TYPES_URL = "config/types";
// export const ENGINE_TYPES_URL = "config/types";

// Dummy for Aircraft Family Types [&&] Engine Family and Type [&&] FlipTrading.

export const MULTI_AIRCRAFT_FAMILY_URL = "/api/aircraft_family_multi/dummy";

// FLIP TRADE

export const FLIPTRADE_URL = "fliptrading/fliptrade";
export const CUSTOMER_VENDER_URL = "config/vendor-dropdown-values";
export const PART_NUMBER_URL = "vendors/dropdown/part-number";
export const DELETE_PART_ROW_URL = "fliptrading/trade/parts";
export const DELETE_FLIPTRADE_ATTACHMENTS_URL = "fliptrading/trade/attachment";

// inventories
export const GET_INVENTORY_URL = "inventory/items";
export const GET_INVENTORY_SINGLE_ROW_URL = "inventory/items/inventory_single_row";
export const GET_INVENTORY_FILTER_URL = "inventory/items/inventory_dropdown";
export const GET_GENERAL_COLUMN_PREFERENCES_URL =
  "config/general-column-preferences";
export const GET_INVENTORY_STOCK_SUMMARY_DETAILS_URL =
  "/inventory/items/inventory_stock_summary";
export const GET_INVENTORY_TEARDOWN_LIST_URL = "/inventory/items/teardown";
export const ADD_COLUMN_PREFERENCES_URL = "config/column-preferences/";
export const UPDATE_COLUMN_PREFERENCES_URL = `config/column-preferences`;
export const GET_IN_REPAIR_INVENTORIES_URL =
  "inventory/items/inventory_in_repair";
export const GET_RO_INVENTORIES_URL = "inventory/items/inventory_repair_orders";
export const GET_RO_INVENTORIES_SINGLE_ROW_URL = "inventory/items/inventory_repair_orders_single_row";
export const GET_REPAIR_ORDER_RAG_LISTING_URL =
  "inventory/repair_order_rag/list";
export const GET_REPAIR_ORDER_RAG_SUMMARY_URL =
  "inventory/repair_order_rag/summary";
export const GET_REPAIR_ORDER_RAG_DETAIL_URL =
  "inventory/repair_order_rag/ro_detail";
export const GET_REPAIR_ORDER_RAG_PRIORITY_VIEW_LISTING_URL =
  "inventory/repair_order_priority/list";
export const GET_REPAIR_ORDER_RAG_PRIORITY_VIEW_SUMMARY_URL =
  "inventory/repair_order_priority/summary";
export const GET_REPAIR_ORDER_RVE_SNAPSHOT_SUMMARY_URL =
  "inventory/repair_order_rve/summary";
export const GET_REPAIR_ORDER_RVE_SNAPSHOT_LISTING_URL =
  "inventory/repair_order_rve/list";
export const GET_REPAIR_ORDER_RVE_SNAPSHOT_CHART_URL =
  "inventory/repair_order_rve/graph";
export const GET_REPAIR_ORDER_VENDOR_SCORECARD_LISTING_URL =
  "inventory/repair_order_vendor_scorecard/list";
export const GET_REPAIR_ORDER_VENDOR_SCORECARD_GRAPH_URL =
  "/inventory/repair_order_vendor_scorecard/graph";
export const GET_REPAIR_ORDER_VENDOR_SCORECARD_RAG_GRAPH_URL =
  "inventory/repair_order_vendor_scorecard/rag_graph";
export const GET_REPAIR_ORDER_ANALYTICS_PRIORITY_TIER_GRAPH_URL =
  "inventory/repair_order_analytics/priority_distribution";
export const GET_REPAIR_ORDER_ANALYTICS_WORKSTREAM_SPLIT_GRAPH_URL =
  "inventory/repair_order_analytics/workstream_split";
export const GET_REPAIR_ORDER_ANALYTICS_RAG_DISTRIBUTION_GRAPH_URL =
  "inventory/repair_order_analytics/rag_distribution";
export const GET_REPAIR_ORDER_ANALYTICS_PHASE_VOLUME_GRAPH_URL =
  "inventory/repair_order_analytics/phase_volume";
export const GET_REPAIR_ORDER_ANALYTICS_DELAY_ATTRIBUTION_GRAPH_URL =
  "inventory/repair_order_analytics/delay_attribution";
export const GET_REPAIR_ORDER_DATA_QUALITY_SUMMARY_URL =
  "inventory/repair_order_data_quality/summary";
export const GET_REPAIR_ORDER_DATA_QUALITY_LISTING_URL =
  "inventory/repair_order_data_quality/list";
//   export const GET_REPAIR_ORDER_RAG_LISTING_URL =
//   "inventory/repair_order_rag/dummy/list";
// export const GET_REPAIR_ORDER_RAG_SUMMARY_URL =
//   "inventory/repair_order_rag/dummy/summary";
// export const GET_REPAIR_ORDER_RAG_DETAIL_URL =
//   "inventory/repair_order_rag/dummy/ro_detail";
export const INVENTORY_EXPORT_EXCEL_URL = "inventory/items/download_inventory";
export const VENDOR_EXPORT_EXCEL_URL = "vendors";
export const EXPORT_PIECE_PART_URL = "inventory/piece_part_master/export";
export const PART_PURCHASE_EXPORT_EXCEL_URL =
  "inventory/piece_part_master/export";
export const UNDER_STOCK_INVENTORIES_URL =
  "inventory/items/inventory_under_stock";
export const UNDER_STOCK_INVENTORIES_SINGLE_ROW_URL =
  "inventory/items/inventory_under_stock_single_row";
export const SLOW_MOVEING_INVENTORIES_URL =
  "inventory/items/slowdown_inventory";
export const SLOW_MOVEING_INVENTORIES_SINGLE_ROW_URL =
  "inventory/items/slowdown_inventory_single_row";
export const GET_INVENTORIES_COUNTRY_NAME_TOTAL_QTY_GRAPH_URL =
  "inventory/graphs/country_name_qty_graph_analytics";
export const GET_INVENTORY_PART_CLASS_TOTAL_QTY_GRAPH_URL =
  "inventory/graphs/part_class_graph_analytics";
export const GET_INVENTORY_TIER_GRAPH_COUNT_GRAPH_URL =
  "inventory/graphs/tier_graph_analytics";
export const GET_INVENTORIES_PART_TYPE_TOTAL_QTY_GARPH_URL =
  "inventory/graphs/tier_graph_analytics";
export const GET_INVENTORIES_RR_URL =
  "inventory/items/inventory_recommended_repair";
// vendors
export const VENDORSLIST_URL = "vendors/list";
export const VENDORS_URL = "vendors";
export const TOTAL_VENDOR_OVERVIEW_URL = "vendors/total_vendor_overview";
export const VENDOR_COMPANY_CLASS_GRAPH_URL = "vendors/graphs/company-class";
export const VENDOR_OFFICE_REGION_GRAPH_URL = "vendors/graphs/office-region";
export const VENDOR_DATE_CREATED_GRAPH_URL = "vendors/graphs/date-created";
export const VENDORS_LIST_EXPORT_URL = "vendors/profile/download-excel";

// export excel url
export const EXPORT__AUTH_EXCEL_URL = "users/export";
export const EXPORT__EXCEL_URL = "export-excel";

// common
export const GET_FILTER_DROPDOWN_URL = "config/dropdown-values";
export const GET_CONSTANTS_URL = "config/constants";
export const GET_FAMILIES__URL = "config/families";
export const GET_FAMILIES__TYPES_URL = "config/families/engine-families";

// project
export const PROJECT_URL = "projects";
export const PROJECT_URL_ENGINE_UTILISATION = "projects/engine-optimization";
export const GET_LLP_VALUATION_LIST_URL = "projects/engine-llp-valuation";
export const GET_LLP_VALUATION_PART_DICRIPTION_OPTION_URL =
  "projects/engine-llp-values";
export const CREATE_LLP_CYCLE_URL = "projects/engine-llp-valuation/cycle";
export const GET_ESCALATON_LIST_URL = "projects/engine-escalation";
export const CREATE_LLP_VALUATION_LIST_URL = "projects/engine-llp-valuation";
export const CREATE_ESCALATON_LIST_URL = "projects/engine-escalation";
export const UPDATE_LLP_VALUATION_LIST_URL = "projects/engine-llp-valuation";
export const UPDATE_ESCALATON_LIST_URL = "projects/engine-escalation/update";
export const DELETE_ESCALATON_LIST_URL = "projects/engine-escalation/delete";
export const SYNC_PROJECT_URL = "projects/merge/crm-opportunity";
export const INITIATE_BAM_URL = "projects/bam/initiate";
//Go for part purchase
export const PIECE_PART_URL = "inventory/piece_part_master";

// assets
export const ASSET_URL = "projects/project-assets";

// harvest list
export const HARVEST_LIST_URL = "projects/harvest-list";

// inventory check
export const INVENTORY_CHECK_URL = "projects/inventory-check";
export const UPDATE_RP_INVENTORY_CHECK_URL =
  "projects/update-inventory-check-repair-percent";
export const UPDATE_LRU_SALES_URL = "projects/lru-sales";
export const INITIATE_PRICING_URL = "projects/initiate-pricing";
export const PRICING_STATE_CHECK_URL = "projects/pricing-calculation-status";
// cash flow

export const CASHFLOW_URL = "projects/cashflow-params";
export const ENGINE_CASHFLOW_URL = "projects/cashflow-params-engine";
export const CASHFLOW_RESULT_URL = "projects/cashflow-result";
export const ENGINE_CASHFLOW_RESULT_URL = "projects/cashflow-engine-result";
export const EXPORT_ENGINE_CASHFLOW_RESULT_EBITA =
  "projects/cashflow-engine-ebita";
export const EXPORT_AIRCRAFT_CASHFLOW_RESULT_EBITA = "projects/cashflow-ebita";

// pricing
export const PRICING_URL = "projects/pricing";
export const SUMMRY_URL = "projects/project_pricing/summary";
export const UPDATE_BULK_RP_PRICING_URL =
  "projects/update-pricing-repair-percent";
export const EXCLUDE_CALC_URL =
  "projects/exclude_calculation/exclude_from_calculation";
export const PRICING_RP_UPDATE_URL = "projects/update-repair-percent";
// ebita
export const EBITA_URL = "projects/cashflow-ebita";
export const ENGINE_EBITA_URL = "projects/cashflow-engine-ebita";

// sample export
export const SAMPLE_EXPORT_URL = "config/sample-import";

// project asset export
export const PROJECT_ASSETS_EXPORT_URL = "projects/projects-assets-export";
export const PROJECT_EXPORT_URL = "projects/projects-export";
export const HARVEST_LIST_EXPORT_URL = "projects/harvest-list-export";
export const INV_CHECK_EXPORT_URL = "projects/inventory-check-export";
export const PRICING_EXPORT_URL = "projects/pricing-export";

// master data
export const AIRCRAFT_MASTER_DATA_URL = "aircraft/partsMaster";
export const IMPORT_ENGINE_MASTER_DATA_URL = "config/engine/partsmaster";
export const ENGINE_PNS_URL = "config/engine/pns";

// delete attachments

export const DELETE_ATTACHEMENTS_URL = "projects/attachment";

// Fliptrade Export URL

export const FLIPTRADE_EXPORT_URL = "fliptrading/trade/export";
// analytics

export const ANALYTICS_URL = "analytics";
export const DEMAND_FORECAST_URL = "analytics/demandForecast";
export const ILS_URL = "config/ilsrecords";
export const VENDOER_QOUTES_URL = "vendors/vendor_quotes";

export const EXPORT__PM_EXCEL_URL = "parts-master/export";

// customer quote dashboard
export const CUSTOMER_QUOTE_KPI_URL = "analytics/customerQuote/summary_cards";
export const CUSTOMER_QUOTE_ACTIVITY_URL =
  "analytics/customerQuote/customer_quote_activity_table";
export const CUSTOMER_QUOTE_GRAPHS_URL =
  "analytics/customerQuote/customer_quote_graphs";
export const ACTIVITY_THRESHOLD_URL = "analytics/activity/threshold";
export const CUSTOMER_QUOTE_HISTORY_TREND_URL =
  "analytics/customerQuote/quote_history_trend";
export const CUSTOMER_PN_URL = "analytics/customerQuote/quoted_parts_table";
export const CUSTOMER_FULL_QUOTES_URL =
  "analytics/customerQuote/full_quoted_records_table";
export const CUSTOMER_EMPLOYEE_ACTIVITY_SUMMARY_URL =
  "analytics/customerQuote/customer_employee_activity_summary";
export const GET_INVENTORY_LATEST_UPDATE_URL =
  "inventory/items/inventory_latest_update";
